var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "正则渠道组编辑",
            visible: _vm.dialogVisible,
            width: "60%",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "section",
            { staticClass: "lists" },
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  attrs: {
                    model: _vm.ruleForm,
                    rules: _vm.rules,
                    "label-position": "left",
                    "label-width": "110px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "渠道组名称", prop: "name" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入渠道组名称",
                          clearable: "",
                          maxlength: "20",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.ruleForm.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "name", $$v)
                          },
                          expression: "ruleForm.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "正则匹配规则", prop: "reg" } },
                    [
                      _c("el-input", {
                        staticClass: "item-input",
                        attrs: {
                          size: "medium",
                          type: "textarea",
                          autosize: { minRows: 2, maxRows: 8 },
                          placeholder:
                            "请输入匹配规则（正则匹配规则和子渠道组两者间至少填写其中一项）",
                        },
                        model: {
                          value: _vm.ruleForm.reg,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "reg", $$v)
                          },
                          expression: "ruleForm.reg",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "子渠道组", prop: "sub_reg_id" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder:
                              "请选择子渠道组（正则匹配规则和子渠道组两者间至少填写其中一项）",
                            multiple: "",
                            filterable: "",
                          },
                          model: {
                            value: _vm.ruleForm.sub_reg_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "sub_reg_id", $$v)
                            },
                            expression: "ruleForm.sub_reg_id",
                          },
                        },
                        _vm._l(_vm.reg_channels, function (v, k) {
                          return _c("el-option", {
                            key: k,
                            attrs: {
                              label:
                                "【" +
                                v.name +
                                "】" +
                                (v.reg && "（") +
                                v.reg.substring(0, 20) +
                                (v.reg.length > 19 ? "..." : "") +
                                (v.reg && "）"),
                              value: v.id,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.onCancel } }, [
                _vm._v("取消"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm("ruleForm")
                    },
                  },
                },
                [_vm._v("确定并同步")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }